var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3599_28519)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: 1104,
    width: 1113,
    height: 1964,
    transform: "rotate(-90 -22 1104)",
    fill: "url(#paint0_linear_3599_28519)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter0_f_3599_28519)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1684.5,
    cy: -49.5,
    r: 361.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52,
    filter: "url(#filter1_f_3599_28519)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 698.5,
    cy: 197,
    rx: 279.5,
    ry: 266,
    fill: "#5200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.5 197C977.5 343.609 852.611 462.5 698.5 462.5C544.389 462.5 419.5 343.609 419.5 197C419.5 50.3914 544.389 -68.5 698.5 -68.5C852.611 -68.5 977.5 50.3914 977.5 197Z",
    stroke: "#5200FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_3599_28519)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1452.5,
    cy: 811,
    rx: 371.5,
    ry: 312,
    fill: "#5200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1823.5 811C1823.5 982.958 1657.48 1122.5 1452.5 1122.5C1247.52 1122.5 1081.5 982.958 1081.5 811C1081.5 639.042 1247.52 499.5 1452.5 499.5C1657.48 499.5 1823.5 639.042 1823.5 811Z",
    stroke: "#5200FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3599_28519",
    x: 823,
    y: -911,
    width: 1723,
    height: 1723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_3599_28519"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3599_28519",
    x: -81,
    y: -569,
    width: 1559,
    height: 1532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_3599_28519"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3599_28519",
    x: 581,
    y: -1,
    width: 1743,
    height: 1624,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_3599_28519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3599_28519",
    x1: 534.5,
    y1: 692.788,
    x2: 534.5,
    y2: 3441.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12132F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12132F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12132F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3599_28519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.8a4c3dc1d3a15141b3944f038b3929e5.svg";
export { ForwardRef as ReactComponent };